module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAkCAMAAACt+qpmAAAAM1BMVEUAAAAAEFwAEVwAElwAEFoAEGAAEVsAEFgAEVsAEVsAElsAEloAEFsAEFoAEVsAEFwAEVsZCZfUAAAAEHRSTlMAQMCAMBDwIODQoJBwYLBQ0l8BfQAAAI1JREFUOMvd0VsOhSAMRVFepQh67fxHexMSTXsQ+Xf97kjk4BTyMe7ePaEqXY5jS1kuG83bWItoP9MOsZKOG8Smo4CgWhK0iOtj1z+0v12FcIT5fIVehmcHuF4tp/ExlcpwppFP8yboMOOhU98RZeqxyaPaP5QJxllx/DCLxTwlIsfz6J3/TuR4a8EQ/wcvyikSTfOy4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/road/icon-username.png
// module id = /+Vt
// module chunks = 0